// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","647":"component---src-pages-markdown-remark-frontmatter-slug-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"351":"df53029aa2113f5a3c9d","532":"cb23338dfbf850dd2661","647":"24fb3ca3ba49df6f26d8","678":"78a3013875eedada6608"}[chunkId] + ".js";
};